import axios from "axios";
import api from "./api";

import { USER_ID } from "@/windowConfig";

export default {
  addPromoter(payload) {
    return axios.post(`${api.url}/accounts/promoter/create`, payload);
  },
  addVoucherCode(payload) {
    return axios.post(`${api.url}/ads/promoter/voucher`, payload);
  },
  getUserFeatureFlags() {
    return axios.get(`${api.url}/users/feature-flags/`);
  },
  getUserFeatureFlagsById(userId) {
    return axios.get(`${api.url}/users/${userId}/feature-flags/`);
  },
  getAccountFeatureFlag(accountId, flagName) {
    return axios.get(
      `${api.url}/accounts/${accountId}/feature-flags/${flagName}`,
      {
        validateStatus: status => [200, 404].includes(status),
      },
    );
  },
  changeCurrency(currencyId) {
    return axios.post(`${api.url}/users/${USER_ID}/currency/${currencyId}`);
  },
  changeLanguage(languageId) {
    return axios.post(`${api.url}/users/${USER_ID}/language/${languageId}`);
  },
  changePassword(payload) {
    return axios.patch(`${api.url}/accounts/password/change`, payload);
  },
  confirmPromotersUpload(validationId, sendEmail) {
    return axios.post(`${api.url}/accounts/promoter/import`, {
      validationId,
      sendEmail,
    });
  },
  createProvider(payload) {
    return axios.post(`${api.url}/providers`, payload);
  },
  createAccount(payload) {
    return axios.post(`${api.url}/accounts`, payload);
  },
  deleteUser(accountId, userId) {
    return axios.delete(`${api.url}/accounts/${accountId}/users/${userId}`);
  },
  disableUser(accountId, userId) {
    return axios.post(
      `${api.url}/accounts/${accountId}/users/${userId}/disable`,
    );
  },
  enableUser(accountId, userId) {
    return axios.post(
      `${api.url}/accounts/${accountId}/users/${userId}/enable`,
    );
  },
  disableAccountFeatureFlag(accountId, feature) {
    return axios.delete(
      `${api.url}/accounts/${accountId}/feature-flags/${feature}`,
    );
  },
  enableAccountFeatureFlag(accountId, feature) {
    return axios.put(
      `${api.url}/accounts/${accountId}/feature-flags/${feature}`,
    );
  },
  getAdvertisersForProvider(provider) {
    return axios.get(`${api.url}/accounts/advertiser-selector`, {
      params: { provider },
    });
  },
  getAccountDetails(accountId) {
    return axios.get(`${api.url}/accounts/${accountId}`);
  },
  getAccounts(params, isPromoter = false) {
    return isPromoter
      ? axios.get(`${api.url}/accounts/listing/promoter`, {
          params,
        })
      : axios.get(`${api.url}/accounts`, {
          params,
        });
  },
  getBranding(accountId) {
    return axios.get(`${api.url}/account/${accountId}/branding`);
  },
  getProviderBranding(providerId) {
    return axios.get(`${api.url}/providers/${providerId}/branding`);
  },
  getCurrencies() {
    return axios.get(`${api.url}/exchange/currency`);
  },
  getCurrency(userId) {
    return axios.get(`${api.url}/users/${userId}/currency`);
  },
  getCSVSettings(accountId) {
    return axios.get(`${api.url}/accounts/${accountId}/csv-settings`);
  },
  getAccountPricing(accountId) {
    return axios.get(`${api.url}/accounts/${accountId}/payment/pricing-type`);
  },
  getPromoterSettings() {
    return axios.get(`${api.url}/accounts/promoter/settings`);
  },
  getProviderPricing(providerId) {
    return axios.get(`${api.url}/providers/${providerId}/payment/pricing-type`);
  },
  getProviderData(providerId) {
    return axios.get(`${api.url}/providers/${providerId}/business`);
  },
  getProviders() {
    return axios.get(`${api.url}/providers`);
  },
  getSessionInfo() {
    return axios.get(`${api.url}/accounts/session-info`);
  },
  getKsefAuthorizationGrants() {
    return axios.get(`${api.url}/ksef/authorization-grants`);
  },
  getUserAccount(accountId, userId) {
    return axios.get(`${api.url}/accounts/${accountId}/users/${userId}`);
  },
  getUsers(accountId) {
    return axios.get(`${api.url}/accounts/${accountId}/users`);
  },
  getManagersOrContacts(accountId) {
    return axios.get(`${api.url}/accounts/${accountId}/managers-or-contacts`);
  },
  deleteAccount(id) {
    return axios.delete(`${api.url}/accounts/delete/${id}`);
  },
  deletePublisherAccount(id) {
    return axios.delete(`${api.url}/account/remove-or-archive-publisher/${id}`);
  },
  resendUserInvitation(userId) {
    return axios.post(`${api.url}/accounts/${userId}/invitation/resend`);
  },
  saveAccountData(accountId, payload) {
    return axios.put(`${api.url}/accounts/${accountId}`, payload);
  },
  saveAdInventory(payload) {
    return axios.post(`${api.url}/ad-inventories`, payload);
  },
  saveBranding(accountId, payload) {
    return axios.post(`${api.url}/account/${accountId}/branding`, payload);
  },
  saveCSVSettings(accountId, payload) {
    return axios.put(`${api.url}/accounts/${accountId}/csv-settings`, payload);
  },
  saveUser(accountId, payload) {
    return axios.post(`${api.url}/accounts/${accountId}/users`, payload);
  },
  savePromoterSettings(payload) {
    return axios.put(`${api.url}/accounts/promoter/settings`, payload);
  },
  saveAccountPricing(accountId, payload) {
    return axios.put(
      `${api.url}/accounts/${accountId}/payment/pricing-type`,
      payload,
    );
  },
  saveProviderPricing(providerId, payload) {
    return axios.put(
      `${api.url}/providers/${providerId}/payment/pricing-type`,
      payload,
    );
  },
  saveProviderData(providerId, payload) {
    return axios.post(`${api.url}/providers/${providerId}/business`, payload);
  },
  uploadPromoters(formData, offerId, lang, sendEmail) {
    return axios.post(
      `${api.url}/accounts/promoter/validate/import/${offerId}?lang=${lang}&sendEmail=${sendEmail}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  },
  checkEmailAvailability(email) {
    return axios.get(`${api.url}/accounts/check/${email}`);
  },
};
